import React, { useEffect, useState } from "react"
import { useHistory, Link, useParams } from "react-router-dom"
import axiosApi from "../../../../../core/interceptor/interceptor";
import { config } from "../../../../../config";
import TextEditor from "../../../../../Util/TextEditor/TextEditor";
import backArrow from "../../../../../assets/arrow-back.svg";
import './sportNotification.css';

function EditSportNotification(props) {
  const history = useHistory();
  const id = useParams().id;
  const [sportNoti, setSportNoti] = useState('');
  const [notification, setNotification] = useState('');

  const getSportWithNoti = () => {
    axiosApi.get(`${config.apiUrl}/sport-notification/${id}`)
    .then((res) => {
      setSportNoti(res?.data?.data);
      setNotification(res?.data?.data?.notification);
    })
  }

  useEffect(() => {
    if (id) {
      getSportWithNoti();
    }
    // eslint-disable-next-line
  }, [id])

  const onFormChange = (e) => {
    console.log(e);
    setNotification(e);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    axiosApi.put(`${config.apiUrl}/sport-notification/edit/${id}`, {notification: notification})
    .then((res) => {
      history.push(`/admin/settings/sport-notification`);
    })
  }

  return (
    <div className="content-wrapper edit-disclaimer-wrapper">
      <div className="header">
        <Link to={`/admin/settings/sport-notification`}><button className="primary-btn back-btn"><img src={backArrow} alt='' />Back to Notifications</button></Link>
        <div className="header-blk">
          <h2>Edit {sportNoti?.title} Notification</h2>
        </div>
      </div>
      <div className="inner-wrapper">
        <form onSubmit={handleSubmit}>
          <TextEditor value={notification} edit={true} key={'sport-notification'} type='notification' onChange={(e) => onFormChange(e)} />
          <button className="search-btn primary-btn" type="submit">Save</button>
        </form>
      </div>
    </div>

  )
}

export default EditSportNotification;